/* eslint-disable */
/*
 origin author: FrementChen
 modify and comment: Max
 兼容性： ES6
 */
import $ from './jquery'
import i18n from './jquery.i18n'
const util = (window.jqueryVMUtil = {
  assign: $.extend,

  before(str, slash, greedy) {
    let index = str.indexOf(slash);

    if (index < 0) {
      return greedy ? str : "";
    } else {
      return str.slice(0, index);
    }
  },

  index(array, fn) {
    return array.index(fn);
  },

  toCamelCase(prop) {
    return prop.replace(/-([a-z])/gi, (m0, m1) => m1.toUpperCase());
  },

  capitalize(str) {
    return str.slice(0, 1).toUpperCase() + str.slice(1);
  },

  isObject(obj) {
    return obj && typeof obj === "object";
  },

  isNullOrUndefined(value) {
    return value === null || value === undefined;
  },

  createFunctionSequence(fn1, fn2) {
    return function () {
      fn1.apply(this, arguments);
      fn2.apply(this, arguments);
    };
  },
});

util.assign(util, {
  //to compile a?.b -> function () { return util.safeProperty(this.a, 'b') }
  safeProperty(obj, keys, restFn) {
    let value = obj;

    if (value === null || value === undefined) {
      return undefined;
    }

    for (let key of keys) {
      value = value[key];

      if (value === null || value === undefined) {
        return undefined;
      }
    }

    if (restFn) {
      return restFn(value);
    } else {
      return value;
    }
  },

  //to compile a?.b = ... -> function () { return util.safeAssign(this.a, 'b', ...) }
  safeAssign(obj, keys, assignedValue) {
    let lastKey = keys.pop();
    let value = util.safeProperty(obj, keys);

    if (value !== null) {
      value[lastKey] = assignedValue;
    }

    return assignedValue;
  },

  //to compile a?.b(...) -> function () { return util.safeCall(this.a, 'b', ...) }
  safeCall(obj, keys, args, restFn) {
    let lastKey = keys.pop();
    let value = util.safeProperty(obj, keys);

    if (value == null || typeof value[lastKey] !== "function") {
      return undefined;
    } else {
      value = value[lastKey](...args);

      if (restFn) {
        return restFn(value);
      } else {
        return value;
      }
    }
  },
});
const VALUE = 0;
const VARIABLE = 1;
const OPERATOR = 2;
const PROPERTY = 3;
const KEYWORD_VALUE = 4;
const KEYWORD_FUNCTION = 5;
const KEYWORD_OPERATOR = 6;
const OBJ_START = 7;
const OBJ_END = 8;
const OBJ_KEY = 9;
const OBJ_COLON = 10;
const OBJ_COMMA = 11;
const BRACKET_START = 12;
const BRACKET_END = 13;

/*
词法解析 750行
 */
//compile a + b -> function () {this.a + this.b}
const lexer = ($.lexer = {
  EXPRESSION_REGEXP: /('(?:\\'|[^'])*?'|"(?:\\"|[^"])*?"|(?:0x\d+|\d*\.\d+|\d+)(?:e\d+)?)|(`(?:\\`|[^`])*?`)|([a-z_$][\w$]*)|(;|[.+\-~!*\/%<>=&^|?:,]+)|([\[\](){}])/gi,

  TEMPLATE_REGEXP: /\$\{(.+?)\}/g,

  FILTER_REGEXP: /\|\s*([\w-]+)(?:((?:\|\||[^|])+))?/g,

  FILTER_FN_REGEXP: /^\(.+?\)$/,

  //{{{a}}} -> {a: this.a}
  DELIMITER_REGEXP: /\{\{([\s\S]+?)\}\}(?!\})/g,

  FOR_LOOP_REGEXP: /^(.+?)\s+(in|of)\s+(.+)$/,

  FOR_IN_LOOP_REGEXP: /^\s*(\w+)?(?:\s*,\s*(.+?))?(?:\s*,\s*(\w+))?\s*$/,

  FOR_OF_LOOP_REGEXP: /^\s*(.+?)?(?:\s*,\s*(\w+))?\s*$/,

  FOR_TO_LOOP_REGEXP: /^(\w+)\s*=\s*(.+?)\s+to\s+(.+?)(?:\s+step\s+(.+))?$/,

  //keywords can be function name, but cant to be the first property name
  KEYWORD_VALUE: util.index([
    "true",
    "false",
    "null",
    "undefined",
    "NaN",
    "Infinity",
    "arguments",
    "this",
    "debugger",
    "function",
    "window",
    "jqueryVMUtil",
  ]),

  //keywords can be function name, but cant to be the first property name
  KEYWORD_FUNCTION: util.index([
    "Object",
    "Array",
    "Boolean",
    "isFinite",
    "isNaN",
    "JSON",
    "Math",
    "Number",
    "String",
    "parseFloat",
    "parseInt",
  ]),

  UNARY_KEYWORD_OPERATOR: util.index(["delete", "new", "typeof", "void"]),

  BINARY_KEYWORD_OPERATOR: util.index(["in", "instanceof"]),

  readerCache: {},
  writterCache: {},
  handlerCache: {},
  delimiterCache: {},
  loopCache: {},

  isSingleVariable(exp) {
    return /^\s*\w+\s*$/.test(exp);
  },

  //a, a.b or a[b], no operator or bracket
  isEntireProperty(exp) {
    return !/[+\-~!*\/%<>=&^|:\(\)\{\}]/.test(exp);
  },

  isDelimiterExpression(exp) {
    let re = lexer.DELIMITER_REGEXP;
    re.lastIndex = 0;

    return re.test(exp);
  },

  toStringCode(str) {
    return (
      "'" +
      str.replace(/'/g, "\\'").replace(/\r/g, "\\r").replace(/\n/g, "\\n") +
      "'"
    );
  },

  bindScope(exp, args = []) {
    let {
      types,
      tokens,
      filterIndex,
      lastExpressionIndex,
      hasSafeGetter,
    } = lexer.parseToTokens(exp, args);

    this.addScopeToTokens(types, tokens);

    if (hasSafeGetter) {
      this.addSafeGetterToTokens(types, tokens);
    }

    let filters = null;
    if (filterIndex > 0) {
      filters = lexer.parseFilters(exp, filterIndex);
    }

    let previousCode = tokens.slice(0, lastExpressionIndex).join("");
    let returnedCode = tokens.slice(lastExpressionIndex).join("");

    return {
      previousCode,
      returnedCode,
      filters,
    };
  },

  parseToTokens(exp, args = []) {
    let re = lexer.EXPRESSION_REGEXP;
    re.lastIndex = 0;

    let objectDeep = 0;
    let expect = VALUE;
    let tokens = [];
    let types = [];
    let lastType = OPERATOR;
    let filterIndex = -1;
    let lastExpressionIndex = 0;
    let hasSafeGetter = false;

    while (true) {
      let m = re.exec(exp);
      if (!m) {
        break;
      }

      let [m0, m1, m2, m3, m4, m5] = m;
      let type;

      //string or number, no change
      if (m1) {
        tokens.push(m1);
        type = VALUE;
        expect = OPERATOR;
      }

      //`template`
      else if (m2) {
        let lastIndex = re.lastIndex;
        tokens.push(this.bindScopeToTemplateString(m2));
        re.lastIndex = lastIndex;

        type = VALUE;
        expect = OPERATOR;
      }

      //property
      else if (m3) {
        if (expect === PROPERTY) {
          type = expect;
          expect = OPERATOR;
          tokens.push(m3);
        } else if (expect === OBJ_KEY) {
          type = OBJ_KEY;
          expect = OBJ_COLON;
          tokens.push(m3);
        } else if (lexer.KEYWORD_VALUE[m3] || args.includes(m3)) {
          type = KEYWORD_VALUE;
          expect = OPERATOR;
          tokens.push(m3);
        } else if (lexer.UNARY_KEYWORD_OPERATOR[m3]) {
          type = KEYWORD_OPERATOR;
          expect = OPERATOR;
          tokens.push(m3 + " ");
        } else if (lexer.BINARY_KEYWORD_OPERATOR[m3]) {
          type = KEYWORD_OPERATOR;
          expect = OPERATOR;
          tokens.push(" " + m3 + " ");
        } else if (lexer.KEYWORD_FUNCTION[m3]) {
          type = KEYWORD_FUNCTION;
          expect = OPERATOR;
          tokens.push(m3);
        } else {
          type = VARIABLE;
          expect = OPERATOR;
          tokens.push(m3);
        }
      }

      //operators
      else if (m4) {
        if (m4 === "|") {
          filterIndex = re.lastIndex - 1;
          break;
        }

        switch (m4) {
          case ",":
            if (expect === OBJ_COLON) {
              let index = tokens.length - 1;
              tokens.push(":");
              tokens.push(tokens[index]);
              types.push(OBJ_COLON);
              types.push(VARIABLE);
            }

            if (objectDeep > 0) {
              expect = OBJ_KEY;
            } else {
              expect = VALUE;
            }
            break;

          case "?.":
            hasSafeGetter = true;

          case ".":
            expect = PROPERTY;
            break;

          case ";":
            lastExpressionIndex = tokens.length + 1;

          default:
            expect = VALUE;
        }

        type = OPERATOR;
        tokens.push(m4);
      } else {
        switch (m5) {
          case "(":
            if (lastType === KEYWORD_VALUE || lastType === KEYWORD_OPERATOR) {
              types[types.length - 1] = VARIABLE;
            }

            type = BRACKET_START;
            expect = VALUE;
            break;

          case "[":
            type = BRACKET_START;
            expect = VALUE;
            break;

          case "{":
            objectDeep++;
            type = OBJ_START;
            expect = OBJ_KEY;
            break;

          case "}":
            if (expect === OBJ_COLON) {
              let index = tokens.length - 1;
              tokens.push(":");
              tokens.push(tokens[index]);
              types.push(OBJ_COLON);
              types.push(VARIABLE);
            }

            type = OBJ_END;

            if (--objectDeep > 0) {
              expect = OBJ_COMMA;
            } else {
              expect = OPERATOR;
            }
            break;

          default:
            type = BRACKET_END;
            expect = OPERATOR;
        }

        tokens.push(m5);
      }

      lastType = type;
      types.push(type);
    }

    if (lastType === KEYWORD_OPERATOR) {
      types[types.length - 1] = VARIABLE;
    }

    return {
      types,
      tokens,
      filterIndex,
      lastExpressionIndex,
      hasSafeGetter,
    };
  },

  //a + b -> this.a + this.b
  //a() -> this._writeScope.a()
  //a=... -> this._writeScope.a = ...
  addScopeToTokens(types, tokens) {
    let variableIndex = -1;
    let variableIndexStack = [];
    let lastType = null;
    let scopeName = "this";
    let assignOrCallScopeName = scopeName + "._writeScope";

    for (let i = 0, len = tokens.length; i < len; i++) {
      let type = types[i];
      let token = tokens[i];

      //add scope
      if (lastType === VARIABLE) {
        switch (token) {
          case "(":
          case "=":
            tokens[variableIndex] =
              assignOrCallScopeName + "." + tokens[variableIndex];
            break;

          default:
            tokens[variableIndex] = scopeName + "." + tokens[variableIndex];
        }
      }

      switch (type) {
        case VARIABLE:
          variableIndex = i;
          break;

        case BRACKET_START:
          variableIndexStack.push(variableIndex);
          variableIndex = -1;
          break;

        case BRACKET_END:
          variableIndex = variableIndexStack.pop();
          break;
      }

      lastType = type;
    }

    if (lastType === VARIABLE) {
      tokens[variableIndex] = scopeName + "." + tokens[variableIndex];
    }
  },

  //a?.b -> util.safeProperty(this.a, ['b'])
  //a?.b?.c -> util.safeProperty(this.a, ['b', 'c'])
  //a?.b.c() -> util.safeProperty(this.a, ['b'], v=>v.c()])
  //a?b(...) -> util.safeCall(this.a, ['b'], ...)
  //a?b = ... -> util.safeAssign(this.a, ['b'], ...)
  addSafeGetterToTokens(types, tokens) {
    let stack = [];
    let variableIndex = -1;
    let restIndex = -1;
    let inCallArgs = false;
    let safeAssignDeep = 0;

    let endOfSafe = (i) => {
      if (restIndex >= 0) {
        if (restIndex < i) {
          tokens[restIndex] = "],v=>v" + tokens[restIndex];
          tokens[i - 1] += ")";
        } else {
          tokens[i - 1] += "])";
        }

        restIndex = -1;
      }
    };

    for (let i = 0, len = tokens.length; i < len; i++) {
      let token = tokens[i];
      let type = types[i];

      if (token === "?.") {
        if (restIndex >= 0) {
          endOfSafe(i);
        }

        tokens[i] = ",[";

        for (i++; i < len; i++) {
          type = types[i];
          token = tokens[i];

          if (token === "?.") {
            tokens[i] = ",";
          } else if (types[i] === PROPERTY) {
            tokens[i] = "'" + token + "'";
          } else {
            break;
          }
        }

        switch (token) {
          case "=":
            tokens[variableIndex] =
              "jqueryVMUtil.safeAssign(" + tokens[variableIndex];
            tokens[i] = "],";
            safeAssignDeep++;
            break;

          case "(":
            tokens[variableIndex] =
              "jqueryVMUtil.safeCall(" + tokens[variableIndex];
            tokens[i] = "],[";
            inCallArgs = true;
            break;

          case ".":
          case "[":
            tokens[variableIndex] =
              "jqueryVMUtil.safeProperty(" + tokens[variableIndex];
            restIndex = i;
            break;

          default:
            tokens[variableIndex] =
              "jqueryVMUtil.safeProperty(" + tokens[variableIndex];
            tokens[i - 1] += "])";
        }
      }

      switch (type) {
        case VARIABLE:
        case KEYWORD_VALUE:
          variableIndex = i;
          break;

        case OPERATOR:
          if (restIndex >= 0 && token !== "." && token !== "=") {
            endOfSafe(i);
          }
          break;

        case BRACKET_START:
          stack.push([variableIndex, restIndex, inCallArgs]);
          variableIndex = -1;
          restIndex = -1;
          break;

        case BRACKET_END:
          if (restIndex >= 0) {
            tokens[restIndex] = "],v=>v" + tokens[restIndex];
            tokens[i - 1] += ")";
          }

          [variableIndex, restIndex, inCallArgs] = stack.pop();

          if (inCallArgs) {
            tokens[i] = "";
            restIndex = i + 1;
          }
          break;
      }
    }

    if (safeAssignDeep > 0) {
      tokens[tokens.length - 1] += ")".repeat(safeAssignDeep);
    }

    if (restIndex >= 0) {
      endOfSafe(tokens.length);
    }
  },

  bindScopeToTemplateString(str) {
    return str.replace(lexer.TEMPLATE_REGEXP, (m0, m1) => {
      return "${" + lexer.bindScope(m1).returnedCode + "}";
    });
  },

  parseFilters(exp, startIndex) {
    let re = lexer.FILTER_REGEXP;
    re.lastIndex = startIndex;

    let reFn = lexer.FILTER_FN_REGEXP;
    let filters = [];

    while (true) {
      let m = re.exec(exp);

      if (!m) {
        break;
      }

      let [, name, argStr] = m;
      let args;

      if (argStr) {
        argStr = argStr.trim();
      }

      if (argStr && reFn.test(argStr)) {
        args = lexer.bindScope(argStr.slice(1, -1)).returnedCode;
      } else if (argStr) {
        args = argStr
          .split(/\s+/)
          .map((v) => `'${v.replace(/'/g, "\\")}'`)
          .join(", ");
      } else {
        args = "";
      }

      filters.push({ name, args });
    }

    return filters;
  },

  //a -> function () { return this.a }
  //a | b c -> function () { return this.filters[b](this.a, 'c') }
  //a | b(c) -> function () { return this.filters[b](this.a, this.c) }
  //a | b(c) | d(e) -> function () { return dFn(this.filters[b](this.a, this.c), this.e) }
  compileReader(exp, ...args) {
    let key = exp + args.map((v) => ";" + v);
    let fn = lexer.readerCache[key];

    if (fn) {
      return fn;
    }

    let { previousCode, returnedCode } = lexer.compileReaderToCode(exp, args);

    return (lexer.readerCache[key] = new Function(
      previousCode + "return " + returnedCode
    ));
  },

  compileReaderToCode(exp, args) {
    let { previousCode, returnedCode, filters } = lexer.bindScope(exp, args);

    if (filters) {
      for (let { name, args } of filters) {
        args = args ? ", " + args : "";
        returnedCode = `this.filters['${name}'](${returnedCode}${args})`;
      }
    }

    return {
      previousCode,
      returnedCode,
    };
  },

  compileHandler(exp) {
    let key = exp;
    let fn = lexer.handlerCache[key];

    if (fn) {
      return fn;
    }

    if (!exp) {
      return (lexer.handlerCache[key] = new Function(""));
    } else if (lexer.isEntireProperty(exp)) {
      let scope = exp.match(/(?:\.\w+|\[.+?\])$/)
        ? exp.replace(/(?:\.\w+|\[.+?\])$/, "")
        : "this._writeScope";
      let { returnedCode } = lexer.bindScope(
        "this." + exp + ".apply(" + scope + ", arguments)"
      );
      return (lexer.handlerCache[key] = new Function(
        "return " + returnedCode
      ));
    } else {
      let { previousCode, returnedCode } = lexer.bindScope(exp, ["event"]);
      return (lexer.handlerCache[key] = new Function(
        "event",
        previousCode + "return " + returnedCode
      ));
    }
  },

  //a -> function (vm, value) { vm.a = value }
  //a | b(c) -> function (vm, value) { vm.a = this.filters[b](value, this.c) }
  //vm is the scope which has own property a
  compileWritter(exp) {
    let key = exp;
    let fn = lexer.writterCache[key];

    if (fn) {
      return fn;
    }

    if (!lexer.isEntireProperty(util.before(exp, "|", true))) {
      throw new Error(`Model expression "${exp}" is not a property`);
    }

    let {
      types,
      tokens,
      filterIndex,
      lastExpressionIndex,
      hasSafeGetter,
    } = lexer.parseToTokens(exp);
    let valueCode = "value";

    if (filterIndex > 0) {
      let filters = lexer.parseFilters(exp, filterIndex);

      for (let { name, args } of filters) {
        args = args ? ", " + args : "";
        valueCode = `this.filters['${name}'](${valueCode}${args})`;
      }
    }

    types.push(OPERATOR);
    tokens.push("=");
    this.addScopeToTokens(types, tokens);
    types.push(KEYWORD_VALUE);
    tokens.push(valueCode);

    if (hasSafeGetter) {
      this.addSafeGetterToTokens(types, tokens);
    }

    let previousCode = tokens.slice(0, lastExpressionIndex).join("");
    let returnedCode = tokens.slice(lastExpressionIndex).join("");

    return (lexer.writterCache[key] = new Function(
      "value",
      previousCode + returnedCode
    ));
  },

  //a {{b}} c -> function () {return 'a' + b + 'c'}
  compileDelimiterExpression(text) {
    let fn = lexer.delimiterCache[text];
    if (fn) {
      return fn;
    }

    let re = lexer.DELIMITER_REGEXP;
    re.lastIndex = 0;

    let exps = [];
    let startIndex = 0;
    let m;

    while ((m = re.exec(text))) {
      let [m0, exp] = m;
      let str = text.slice(startIndex, re.lastIndex - m0.length);

      if (str) {
        exps.push(lexer.toStringCode(str));
      }

      let { previousCode, returnedCode } = lexer.compileReaderToCode(exp);
      exps.push("(" + previousCode + returnedCode + ")");

      startIndex = re.lastIndex;
    }

    if (startIndex < text.length) {
      exps.push(lexer.toStringCode(text.slice(startIndex)));
    }

    if (exps.length > 1) {
      exps.push("''");
    }

    return (lexer.delimiterCache[text] = new Function(
      "return " + exps.join("+")
    ));
  },

  compileIfStatements(exps, hasElse) {
    let codes = [];

    for (let i = 0, len = exps.length; i < len; i++) {
      let exp = exps[i];
      let { previousCode, returnedCode } = lexer.compileReaderToCode(exp);

      codes.unshift(previousCode);
      codes.push((i > 0 ? "else " : "") + `if(${returnedCode}){return ${i}}`);
    }

    if (hasElse) {
      codes.push(`else{return ${exps.length}}`);
    } else {
      codes.push("else{return -1}");
    }

    let exp = codes.join("");
    let fn = lexer.readerCache[exp];
    if (fn) {
      return fn;
    }

    return (lexer.readerCache[exp] = new Function(exp));
  },

  parseForLoop(exp) {
    let loop = this.loopCache[exp];
    if (loop) {
      return loop;
    }

    let m = exp.match(lexer.FOR_LOOP_REGEXP);
    let valueExp;

    if (m) {
      let [, props, type, dataKey] = m;

      loop = { type, dataKey };

      if (type === "in") {
        m = props.match(lexer.FOR_IN_LOOP_REGEXP);

        if (!m) {
          throw new Error(`"${exp}" is not a valid "for" expression`);
        }

        let [, keyKey, valueKey, indexKey] = m;

        loop.keyKey = keyKey;
        loop.indexKey = indexKey;
        valueExp = valueKey;
      } else if (type === "of") {
        m = props.match(lexer.FOR_OF_LOOP_REGEXP);

        if (!m) {
          throw new Error(`"${exp}" is not a valid "for" expression`);
        }

        let [, valueKey, indexKey] = m;

        loop.indexKey = indexKey;
        valueExp = valueKey;
      }
    } else {
      m = exp.match(lexer.FOR_TO_LOOP_REGEXP);

      if (!m) {
        throw new Error(`"${exp}" is not a valid "for" expression`);
      }

      let [, valueKey, fromKey, toKey, stepKey] = m;

      if (!lexer.isSingleVariable(valueKey)) {
        throw new Error(`"${exp}" is not a valid "for" expression`);
      }

      loop = {
        type: "to",
        fromKey,
        toKey,
      };

      loop.stepKey = stepKey || 1;
      valueExp = valueKey;
    }

    if (valueExp) {
      loop.valueAssigner = lexer.parseAssigner(valueExp);
    }

    return (this.loopCache[exp] = loop);
  },

  parseAssigner(exp) {
    let { previousCode, returnedCode } = lexer.bindScope(exp);
    return new Function(
      "value",
      "(" + previousCode + returnedCode + " = value)"
    );
  },
});

//watcher, watch a expression and can get or set value on a vm
//options include {vm, exp, getter, handler, scope}
function Watcher(options) {
  this.isDir = !!options.scope;

  util.assign(this, options);

  if (!this.isDir) {
    this.scope = this.vm;

    if (!this.getter) {
      this.getter = lexer.compileReader(this.exp);
    }
  }

  this.value = this.get();
}

Watcher.prototype = {
  isDir: false,

  get() {
    let value;

    Watcher.running = this;

    try {
      value = this.getter.call(this.vm);
    } catch (err) {
      console.warn(`Failed to run "${this.exp}" - `, err.stack);
      return this.value;
    }

    return value;
  },

  set(value) {
    let { vm } = this;
    let setter = lexer.compileWritter(this.exp);

    setter.call(vm, value);
  },

  //returns needs to update and truly updated
  update() {
    let oldValue = this.value;
    let newValue = this.get();

    if (newValue !== oldValue || (newValue && typeof newValue === "object")) {
      this.value = newValue;
      this.handler.call(this.scope, newValue, oldValue);

      if (!this.isDir) {
        queues.update();
      }
    }
  },

  destroy() {},
};

//run directive type of watcher, then user created watcher, then task
//update 调用时机:
//	after setTimeout, setInterval
//	after ajax request
//	after event handler calling
//	after watchers trigger
const queues = {
  started: null,

  flushing: false,

  tasks: [],

  addTask(fn, scope) {
    if (scope) {
      fn = fn.bind(scope);
    }

    this.tasks.push(fn);

    if (!this.flushing) {
      this.startDeferredFlushingIfNot();
    }
  },

  update() {
    if (!this.flushing) {
      this.startDeferredFlushingIfNot();
    }
  },

  startDeferredFlushingIfNot() {
    if (!this.started) {
      Promise.resolve().then(() => {
        this.doFlushing();
      });

      this.started = true;
    }
  },

  doFlushing() {
    let { tasks } = this;

    this.flushing = true;

    for (let vm of $.topVMs) {
      vm.digest();
    }

    if (tasks.length > 0) {
      // 似乎没必要 执行2次循环？
      for (let i = 0; i < 2 && tasks.length > 0; i++) {
        for (let j = 0; j < tasks.length; j++) {
          tasks[j]();
        }

        tasks.splice(0, tasks.length);

        for (let vm of $.topVMs) {
          vm.digest();
        }
      }

      if (tasks.length > 0) {
        console.warn(
          "There are still some updatings not done after digest for 2 times"
        );
      }
    }

    this.started = false;
    this.flushing = false;
  },
};

$.topVMs = [];
// 将任务储存起来， 等待异步更新时调用
$.nextTick = queues.addTask.bind(queues);
// 将储存的异步任务放入 event loop
$.digest = queues.update.bind(queues);

$.digestAwait = function (value) {
  $.digest();

  if (value && value.then) {
    value.then($.digest);
  }
};

/** Component & Directive **/
let expressionCache = {};

$.components = {};
$.directives = {};
$.filters = {};
$.mixins = {};
$.transitions = {};

/**
 * 注册组件， 默认继承 BaseComponent
 * @param name 组件名称
 * @param superName 继承组件的名称 {optional}
 * @param overwrite 组件选项， 会覆盖继承组件的同名选项
 * @returns {*}
 */
$.registerComponent = function (name, superName, overwrite = {}) {
  if (name && $.components[name]) {
    console.warn('Component "' + name + '" has been registered');
    return
  }

  if (typeof superName === "object" && !Array.isArray(superName)) {
    overwrite = superName;
    superName = "";
  }

  overwrite._name = name;

  //old API
  overwrite.selector = overwrite.selector || "";
  overwrite.ref = overwrite.ref || {};
  overwrite.mixins = overwrite.mixins || overwrite.plugins || [];

  let proto = {};
  let superProtos = [];

  //处理多继承
  if (superName) {
    let superNames = Array.isArray(superName) ? superName : [superName];
    for (let superName of superNames) {
      superProtos.push($.getComponent(superName).prototype);
    }

    //以第一个超类为蓝本, 后面的通过拷贝属性的方式添加
    proto.__proto__ = superProtos[0];
  } else {
    proto.__proto__ = BaseComponent.prototype;
  }

  //覆写以及属性合并
  for (let superProto of superProtos) {
    $._mergeOptions(overwrite, superProto);

    if (superProto !== proto) {
      util.assign(proto, superProto);
    }
  }
  // 以上代码 全是为了构造出 proto对象

  util.assign(proto, overwrite);

  //创建类
  let Com = new Function(`
		return function ${util.capitalize(util.toCamelCase(name))} (options) {
		  if (!$.BaseComponent) debugger;
			return $.BaseComponent.call(this, options)
		}
	`)();

  Com.prototype = proto;

  if (name) {
    $.components[name] = Com;
  }

  return Com;
};

$._mergeOptions = function (options, proto) {
  for (let prop of ["onCreated", "onReady", "onDestroy"]) {
    if (options[prop] && proto[prop]) {
      options[prop] = util.createFunctionSequence(proto[prop], options[prop]);
    }
  }

  if (options.mixins && proto.mixins) {
    options.mixins = proto.mixins.concat(options.mixins);
  }

  //old API
  if (options.ref && proto.ref) {
    options.ref = util.assign({}, proto.ref, options.ref);
  }
};

$.getComponent = function (name) {
  let Com = $.components[name];

  if (!Com) {
    throw new Error('Component "' + name + '" is not registered');
  }

  return Com;
};

$.hasComponent = function (name) {
  return !!$.components[name];
};

$.registerDirective = function (name, overwrite) {
  overwrite.name = name;
  overwrite.__proto__ = BaseDirective.prototype;

  let Directive = function () {
    BaseDirective.apply(this, arguments);
  };
  Directive.prototype = overwrite;
  $.directives[name] = Directive;

  return Directive;
};

$.getDirective = function (name) {
  return $.directives[name];
};

$.registerMixin = function (name, options) {
  if ($.mixins[name]) {
    console.warn('Mixin "' + name + '" is registered');
  }

  $.mixins[name] = options;
};

$.registerFilter = function (name, fn) {
  if ($.filters[name]) {
    console.warn('Filder "' + name + '" is registered');
  }

  $.filters[name] = fn;
};

$.registerTransition = function (name, options) {
  if ($.transitions[name]) {
    console.warn('Transition "' + name + '" is registered');
  }

  $.transitions[name] = options;
};

// 最重要的类
function BaseComponent(options) {
  $.Emitter.call(this);

  if (options) {
    if (options._inherit) {
      options.template = options.template || null;
      options.appendTo = options.appendTo || null;
      options.target = options.target || null;
    } else {
      //old API
      if (this.init && options.init) {
        options.init = util.createFunctionSequence(this.init, options.init);
      }

      $._mergeOptions(options, this);
    }
  }

  util.assign(this, options);

  if (this._inherit) {
    this._name = "";
    this._writeScope = this.parent._writeScope;
    this._isCreatedByComponentDir = false;
  } else {
    this._writeScope = this;
    this._closest = this._closest || this.parent;
    this._initMixins();

    //old API
    if (this.init) {
      this.on("ready", this.init, this);
    }

    this._initEvents();
  }

  this._directives = [];
  this._watchers = [];
  this._isReady = false;

  this.el = $(this.el);

  if (this._name && this.el[0]) {
    this._initPropsFromEl(this.el);
  }

  this._initEl(this.el);

  if (!this._isCreatedByComponentDir) {
    if (window.asyncMode) {
      setTimeout(() => {
        this._onDirsLinked();
        this._onChildrenReady();
      })
    } else {
      this._onDirsLinked();
      this._onChildrenReady();
    }
  }
}

$.BaseComponent = BaseComponent;

BaseComponent.prototype = {
  __proto__: $.Emitter.prototype,

  template: "",

  el: null,

  mixins: null,

  target: "",

  onCreated: null,

  onReady: null,

  onDestroy: null,

  //old API
  isOld: false,
  selector: "",
  init: null,

  //inner properties
  _name: "",

  _oldEl: null,

  _writeScope: null,

  _inherit: false,

  filters: $.filters,

  isReady: false,

  destroyed: false,

  _initEvents() {
    if (this.onCreated) {
      this.on("created", this.onCreated, this);
    }

    if (this.onReady) {
      this.on("ready", this.onReady, this);
    }

    if (this.onDestroy) {
      this.on("destroy", this.onDestroy, this);
    }
  },

  _initMixins() {
    if (this.mixins) {
      for (let i = 0; i < this.mixins.length; i++) {
        let name = this.mixins[i];
        let options = $.mixins[name];

        this._initEvents(options);

        for (let key in options) {
          if (!(key in this)) {
            this[key] = options[key];
          }
        }
      }
    }
  },

  // 从元素attrs 分析 props
  _initPropsFromEl(el) {
    let attrs = el[0].attributes;
    let props = {};

    for (let i = 0, len = attrs.length; i < len; i++) {
      let prop = attrs[i].name;
      let value = attrs[i].value;

      if (!["ref"].includes(prop)) {
        if (prop.startsWith("data-")) {
          prop = prop.slice(5);
        } else if (this.isOld) {
          continue;
        }

        let camelProp = util.toCamelCase(prop);
        let type = typeof this[camelProp];

        if (type !== "undefined") {
          if (type === "number") {
            value = Number(value) || 0;
          } else if (type === "boolean") {
            value = value === "false" ? false : true;
          }

          props[camelProp] = value;
        }
      }
    }

    //old API
    if (this.props) {
      for (let prop of this.props) {
        let value = el.attr("data-" + prop);
        if (typeof value === "string") {
          let camelProp = util.toCamelCase(prop);
          let type = typeof this[camelProp];

          if (type === "number") {
            value = Number(value) || 0;
          } else if (type === "boolean") {
            value = value === "false" ? false : true;
          }

          props[camelProp] = value;
        }
      }
    }

    util.assign(this, props);
  },

  /*
  初始化元素: 插入文档
   */
  _initEl(oldEl) {
    this.directives = [];
    this.children = [];

    if (this.parent) {
      this.parent.children.push(this);
    }

    if (!oldEl.length || (this._name && !this.isOld)) {
      if (this.template) {
        this.el = this._getEl();
      } else {
        throw new Error(
          '"' +
          (this._name || "anaoymous instance") +
          '" must have a "template" property or an element as first argument!'
        );
      }
    } else {
      this.el = oldEl;

      //if is a anaoymous component, can binded twice
      if (oldEl.com() && this._name) {
        throw new Error(
          '"el" already binded to a "' +
          (oldEl.com()._name || "anaoymous") +
          '" component!'
        );
      }
    }

    if (this._name) {
      // 与vue 有冲突 is => is-component
      this.el.attr("is", this._name);
    }

    if (this.target) {
      this.el.appendTo(this.target);
    }

    this._oldEl = oldEl;
    this.el[0]._com = this;
  },

  _getEl() {
    return this._getElFromTemplate(this.template);
  },
  // 将模版转化为Element

  _getElFromTemplate(template) {
    if (typeof template === "function") {
      template = template.call(this);
    }

    template = i18n.trans(template);

    //old API
    template = template.format(this);

    let el = $(template);

    //old API
    if (el.is(".win-mask")) {
      let oldMaskEl = el;
      el = el.find(".win");
    }

    return el;
  },

  createFromHTML(html) {
    let el = this._getElFromTemplate(html);

    this._initSubForEl(el);

    //old API
    this.initSubBySelector(el);

    return el;
  },

  _onDirsLinked() {
    this.trigger("created");

    this._initSubForEl(this.el);

    //old API
    this.initSubBySelector(this.el);

    let oldEl = this._oldEl;

    //when used template
    if (this.el[0] !== oldEl[0]) {
      let slotEl = this.el.find("slot");

      if (oldEl[0]) {
        this._copyAttributes(oldEl[0], this.el[0]);

        if (slotEl.length) {
          if (oldEl[0].innerHTML.trim()) {
            slotEl.replaceWith(oldEl[0].childNodes);
          } else {
            slotEl.replaceWith(slotEl[0].childNodes);
          }
        } else {
          this.el.append(oldEl[0].childNodes);
        }

        oldEl.replaceWith(this.el);
      } else {
        oldEl.remove();

        if (slotEl[0]) {
          slotEl.replaceWith(slotEl[0].childNodes);
        }
      }
    }

    //old API
    this.applyRef();
    this.callMixinsInit();

    if (!this.parent) {
      $.topVMs.push(this);
    }
  },

  _onChildrenReady() {
    this.isReady = true;
    this.trigger("ready");
  },

  _initSubForEl(el) {
    el.each((index, item) => {
      if (item.nodeType === 1) {
        this._compileEl(item, this);
      }
    });
  },

  _compileEl(el, closest) {
    let childNodes = Array.from(el.childNodes);
    let { com, isTerminal } = this._compileDirectives(el, closest);

    closest = com || closest;

    if (!isTerminal) {
      for (let i = 0, len = childNodes.length; i < len; i++) {
        this._compileEl(childNodes[i], closest);
      }
    }

    if (com) {
      com._onChildrenReady();
    }
  },
  /*
  编译指令
   */
  _compileDirectives(el, closest) {
    let dirs = [];
    let com;
    let isTerminal = false;

    if (el.nodeType === 3) {
      let text = el.textContent;

      if (lexer.isDelimiterExpression(text)) {
        dirs.push({
          name: "text",
          exp: text,
          isTextual: true,
        });
      }
    } else if (el.nodeType === 1) {
      for (
        let i = 0, attributes = el.attributes, len = attributes.length;
        i < len;
        i++
      ) {
        let { name, value } = attributes[i];
        let dir = this._getDirFromAttribute(el, name, value);
        if (dir) {
          dirs.push(dir);
        }
      }

      let localName = el.localName;
      if (localName === "slot") {
        let oldEl = this._oldEl;
        if (oldEl[0] && oldEl[0].innerHTML.trim()) {
          el.innerHTML = "";
        }
      } else if (!el._com && $.components[localName]) {
        dirs.push({
          name: "component",
          exp: localName,
          closest,
        });
      }
    }

    dirs.sort((a, b) => {
      return (
        $.getDirective(b.name).prototype.priority -
        $.getDirective(a.name).prototype.priority
      );
    });

    if (el.nodeType === 1) {
      isTerminal = this._checkTerminal(dirs);
      this._cleanDirAttributes(dirs, el);
    }

    for (let dir of dirs) {
      dir.el = el;
      dir = this.newDirective(dir.name, dir);
      this._directives.push(dir);

      if (dir.name === "component") {
        com = dir.com;
        el = com.el;
      }
    }

    if (com) {
      com._onDirsLinked();
    }

    return { com, isTerminal };
  },

  // 从Element属性中分析出指令
  // 默认为bind指令
  _getDirFromAttribute(el, nodeName, nodeValue) {
    if (
      nodeName.startsWith("@") ||
      nodeName.startsWith(":") ||
      nodeName.startsWith("f-") ||
      //old API
      nodeName === "ref" ||
      nodeName === "trans"
    ) {
      let { name, prop, mods } = this._parseNodeName(nodeName);

      if ($.getDirective(name)) {
        let dir = {
          name,
          exp: nodeValue,
          nodeName,
        };

        if (prop) {
          dir.prop = prop;
        }

        if (mods) {
          dir.mods = mods;
        }

        return dir;
      } else {
        console.warn(`Directive "${name}" is not registered`);
      }
    } else if (lexer.isDelimiterExpression(nodeValue)) {
      let dir = {
        name: "bind",
        prop: "attr",
        mods: [nodeName],
        exp: nodeValue,
        isTextual: true,
      };

      return dir;
    }

    return null;
  },
  // f-开头： 匹配字母或-
  // @开头： 指令为 on
  // :开头：指令为bind
  // 其他： 匹配字母或-

  //支持修饰符： f-win.stop.prevent
  // 修饰符分 prop、mods

  _parseNodeName(nodeName) {
    let name, rest, prop, mods;

    if (nodeName.startsWith("f-")) {
      let unprefixNodeName = nodeName.replace("f-", "");
      name = unprefixNodeName.match(/^[\w-]+/)[0];
      rest = unprefixNodeName.slice(name.length);
    } else if (nodeName[0] === "@") {
      name = "on";
      rest = nodeName;
    } else if (nodeName[0] === ":") {
      name = "bind";
      rest = nodeName;
    } else {
      name = nodeName.match(/^[\w-]+/)[0];
      rest = nodeName.slice(name.length);
    }

    if (rest) {
      [prop, ...mods] = rest.split(".");

      if (prop) {
        prop = prop.slice(1);
      }
    }

    return {
      name,
      prop,
      mods,
    };
  },

  _checkTerminal(dirs) {
    let terminalIndex = dirs.findIndex((dir) => {
      return $.getDirective(dir.name).prototype.isTerminal;
    });

    if (terminalIndex > -1) {
      let dir = dirs[terminalIndex];
      dirs.splice(terminalIndex + 1, dirs.length - terminalIndex - 1);

      return true;
    } else {
      return false;
    }
  },

  _cleanDirAttributes(dirs, el) {
    for (let dir of dirs) {
      if (dir.nodeName) {
        //old API, 如果删除该引用, 会造成本应属于外层组件的 ref 被意外删除
        let useOuterRef = dir.nodeName === "ref" && this.isOld;

        if (!useOuterRef) {
          el.removeAttribute(dir.nodeName);
        }
      }
    }
  },

  newComponent(name, options) {
    options.parent = this;
    return $.newComponent(name, options);
  },

  newDirective(name, options) {
    let Dir = $.getDirective(name);

    if (!Dir) {
      throw new Error('No directive named "' + name + '" existed');
    }

    options.vm = this;

    if (options.value) {
      options.exp = options.value;
      options.isLiteral = true;
    }

    return new Dir(options);
  },

  _copyAttributes(from, to) {
    for (let i = 0, len = from.attributes.length; i < len; i++) {
      let attr = from.attributes[i];
      let name = attr.name;
      let value = attr.value;

      let mergedValue = value;
      let toValue = to.getAttribute(name);

      if ((name === "class" || name === "style") && toValue) {
        if (name === "style") {
          mergedValue += /;\s*$/.test(value) ? "" : "; ";
        } else if (name === "class") {
          mergedValue += /\s+$/.test(value) ? "" : " ";
        }

        mergedValue += toValue;
      }

      to.setAttribute(name, mergedValue);
    }
  },

  watch(exp, handler, immediate) {
    let getter = null;

    if (typeof exp === "function") {
      getter = exp;
      exp = exp.toString();
    }

    let watcher = new Watcher({
      vm: this,
      exp,
      getter,
      handler,
    });

    this._watchers.push(watcher);

    if (immediate) {
      handler.call(this, watcher.value);
    }

    return watcher;
  },

  watchOnce(exp, handler) {
    let wrappedHandler = function (...args) {
      this.unwatch(watcher);
      handler.apply(this, args);
    };

    return this.watch(exp, wrappedHandler);
  },

  watchUntil(exp, handler) {
    let wrappedHandler = function (value, oldValue) {
      if (value) {
        this.unwatch(watcher);
        handler.call(this, value, oldValue);
      }
    };

    return this.watch(exp, wrappedHandler);
  },

  unwatch(watcher) {
    let index = this._watchers.findIndex((v) => v === watcher);

    if (index > -1) {
      this._watchers[index].destroy();
      this._watchers.splice(index, 1);
    }
  },

  digest(forceDigest) {
    for (let watcher of this._watchers) {
      watcher.update(forceDigest);
    }

    for (let child of this.children) {
      child.digest(forceDigest);
    }
  },

  //not include self
  closest(name) {
    if (!name) {
      return this._closest;
    }

    let names = name.split(/\s*,\s*/);
    let closest = this._closest;
    let Coms = names.map((name) => $.getComponent(name));

    while (closest) {
      if (Coms.some((Com) => closest instanceof Com)) {
        return closest;
      }

      closest = closest._closest;
    }

    return null;
  },

  destroy(fromParent = false) {
    this.el.remove();

    if (!this.parent) {
      $.topVMs.remove(this);
    } else if (!fromParent) {
      this.parent.children.remove(this);
    }

    for (let i = 0; i < this.children.length; i++) {
      this.children[i].destroy(true);
    }

    for (let i = 0; i < this.directives.length; i++) {
      this.directives[i].destroy();
    }

    delete this.el[0]._com;
    this.destroyed = true;
    this.trigger("destroy");
  },

  //old API
  initSubBySelector(el) {
    let subEls = [];

    for (let name in $.components) {
      let Com = $.getComponent(name);
      let selector = Com.prototype.selector;

      if (selector) {
        let els = [];
        for (let item of [...el]) {
          els.push(...item.querySelectorAll(selector));

          if (item.matches ? item.matches(selector) : $(item).is(selector)) {
            els.unshift(item);
          }
        }

        for (let foundEl of els) {
          if (foundEl._com) {
            continue;
          }

          foundEl._com_name = name;
          subEls.push(foundEl);
        }
      }
    }

    for (let name in $.directives) {
      let Dir = $.directives[name];
      let selector = Dir.prototype.selector;

      if (selector) {
        let els = [];
        for (let item of [...el]) {
          els.push(...item.querySelectorAll(selector));

          if (item.matches ? item.matches(selector) : $(item).is(selector)) {
            els.unshift(item);
          }
        }

        for (let foundEl of els) {
          if (foundEl._dirs && foundEl._dirs[name]) {
            continue;
          }

          if (foundEl._dir_name_map) {
            foundEl._dir_name_map[name] = true;
          } else {
            foundEl._dir_name_map = {};
            foundEl._dir_name_map[name] = true;
            subEls.push(foundEl);
          }
        }
      }
    }

    if (subEls[0] && subEls[0].compareDocumentPosition) {
      subEls.sort(function (a, b) {
        let pos = a.compareDocumentPosition(b);
        return pos & 2 ? 1 : -1;
      });
      subEls = $(subEls);
    }

    for (let i = 0; i < subEls.length; i++) {
      let subEl = subEls[i];
      let comName = subEl._com_name;

      if (comName) {
        delete subEl._com_name;

        $.newCom(comName, subEl, {
          parent: this,
          isOld: true,
        });
      }

      let dirNameMap = subEl._dir_name_map;
      if (dirNameMap) {
        delete subEl._dir_name_map;
        let dirNameList = Object.keys(dirNameMap);

        for (let j = 0; j < dirNameList.length; j++) {
          let dirName = dirNameList[j];

          $.newDirective(dirName, subEl, {
            isOld: true,
          });
        }
      }
    }
  },

  //old API
  callMixinsInit() {
    if (this.mixins) {
      for (let i = 0; i < this.mixins.length; i++) {
        let name = this.mixins[i];
        let options = $.mixins[name];

        if (options.init) {
          options.init.call(this);
        }
      }
    }
  },

  //old API
  applyRef() {
    if (this.ref) {
      let el = this.el;

      for (let name in this.ref) {
        let selector = this.ref[name];
        this[name] = el.find(selector);
      }
    }
  },

  //old API
  callSuper(name) {
    $.com(name).prototype.init.call(this);
  },
};

function BaseDirective(options) {
  $.Emitter.call(this);

  if (options) {
    util.assign(this, options);
  }

  let el = $(this.el);

  if (el[0].nodeType === 1) {
    this._initPropsFromEl(el);
  }

  this._initEl(el);

  //old API
  this.applyRef();

  //old API
  if (this.init) {
    this.init();
  }

  if (this.isOld) {
    if (this.bind) {
      this.bind();
    }
  } else {
    this.prepareWatcherGetter();
    this.initBind();
  }
}

BaseDirective.prototype = {
  __proto__: $.Emitter.prototype,

  el: null,

  vm: null,

  exp: "",

  getter: null,

  bind: null,

  unbind: null,

  priority: 0,

  //old API
  init: null,
  selector: "",

  //inner properties
  destroyed: false,

  _initEl(el) {
    this.el = el;
    el[0]._dirs = el[0]._dirs || {};
    el[0]._dirs[this.name] = this;
  },

  _initPropsFromEl: BaseComponent.prototype._initPropsFromEl,

  camelCase: BaseComponent.prototype.camelCase,

  //old API
  applyRef: BaseComponent.prototype.applyRef,

  destroy() {
    delete this.el[0]._dirs[this.name];
    this.destroyed = true;

    if (this.unbind) {
      this.unbind();
    }

    //for old API
    if (this.onDestroy) {
      this.onDestroy();
    }
  },

  prepareWatcherGetter() {
    let { exp, name, el } = this;
    let getter = null;

    if (this.isLiteral) {
      if (lexer.isDelimiterExpression(exp)) {
        getter = lexer.compileDelimiterExpression(exp);
      }
    } else if (this.isTextual) {
      getter = lexer.compileDelimiterExpression(exp);
    } else if (this.isListener) {
      getter = lexer.compileHandler(exp, "event");
    } else if (name === "if") {
      let exps = [exp];
      let els = [el[0]];
      let hasElse = false;
      let nextEl = el[0].nextElementSibling;

      while (nextEl) {
        if (nextEl.hasAttribute("f-else-if")) {
          exps.push(nextEl.getAttribute("f-else-if"));
          els.push(nextEl);
        } else if (nextEl.hasAttribute("f-else")) {
          els.push(nextEl);
          hasElse = true;
          break;
        } else {
          break;
        }

        nextEl = nextEl.nextElementSibling;
      }

      this.els = els;
      getter = lexer.compileIfStatements(exps, hasElse);
    } else if (name === "for") {
      let loop = (this.loop = lexer.parseForLoop(exp));
      let { type } = loop;

      if (type === "to") {
        getter = lexer.compileReader(
          `[${loop.fromKey}, ${loop.toKey}, ${loop.stepKey}]`
        );
      } else {
        getter = lexer.compileReader(loop.dataKey);
      }
    } else if (exp) {
      getter = lexer.compileReader(exp);
    }

    this.getter = getter;
  },

  initBind() {
    let value;
    let { getter, exp, vm } = this;

    if (this.isListener) {
      value = getter;
    } else if (this.update && getter) {
      let watcher = new Watcher({
        vm,
        exp,
        getter,
        handler: this.update,
        scope: this,
      });

      vm._watchers.push(watcher);
      this.watcher = watcher;
      value = watcher.value;
    } else if (getter) {
      value = getter.call(vm);
    } else if (this.isLiteral) {
      value = exp;
    }

    if (this.bind) {
      this.bind();
    }

    if (this.update) {
      this.update(value);
    }
  },
};

function SingleInstance(el, options) {
  $.Emitter.call(this);

  if (options) {
    util.assign(this, options);
  }

  this._initMixins();

  //old API
  if (this.init) {
    this.on("ready", this.init, this);
  }

  if (!this._inherit) {
    this._initEvents(this);
  }

  this.trigger("created");

  this.el = $(el);

  //old API
  this.callMixinsInit();
  this.applyRef();

  this.isReady = true;
  this.trigger("ready");
}

SingleInstance.prototype = BaseComponent.prototype;

//"name" and "el" are optional
$.newComponent = function (name, options) {
  if (typeof name !== "string") {
    options = name;
    name = "";
  }

  let Com;
  if (!name) {
    Com = BaseComponent;
  } else {
    Com = $.getComponent(name);
  }

  return new Com(options);
};

$.newApp = function (options) {
  if (options.el && $(options.el).com()) {
    throw new Error("Cant call $.newApp twice on a same element");
  }

  return $.newComponent(options);
};

$.instance = function (el, options) {
  if (typeof el === "object" && !(el instanceof $)) {
    options = el;
    el = null;
  }

  return new SingleInstance(el, options);
};

$.fn.com = function () {
  return this[0] ? this[0]._com : null;
};

$.fn.dir = function (name) {
  if (this[0] && this[0]._dirs) {
    return this[0]._dirs[name] || null;
  } else {
    return null;
  }
};

/*
directives priorities:
  1000 - skip and else, else-if
   900 - for
   800 - component
   700 - if
   600 - model & binds
   500 - out & let, binds ready now
     0 - on
     0 - element related directives
*/

$.registerDirective("text", {
  update(value) {
    let { el } = this;
    el[0].textContent = util.isNullOrUndefined(value) ? "" : String(value);
  },
});

$.registerDirective("html", {
  update(value) {
    let { el } = this;
    let newValue = util.isNullOrUndefined(value) ? "" : value;

    if (el[0].isContentEditable) {
      if (newValue !== el[0].innerHTML) {
        el[0].innerHTML = newValue;
      }
    } else {
      el[0].innerHTML = newValue;
    }
  },
});

$.registerDirective("enable", {
  update(value) {
    let { el } = this;

    if (value) {
      el[0].removeAttribute("disabled");
    } else {
      el[0].setAttribute("disabled", "");
    }
  },
});

$.registerDirective("disable", {
  update(value) {
    let { el } = this;

    if (value) {
      el[0].setAttribute("disabled", "");
    } else {
      el[0].removeAttribute("disabled");
    }
  },
});

$.registerDirective("ref", {
  isLiteral: true,

  update(ref) {
    let { el, vm } = this;
    let com = el.com();

    if (com && !com._inherit && com !== vm && !com.isOld) {
      vm[ref] = com;
    } else {
      if (vm[ref] && vm[ref].length > 0) {
        vm[ref] = vm[ref].add(el);
      } else {
        vm[ref] = el;
      }
    }
  },
});

$.registerDirective("cloak", {
  isLiteral: true,
});

//supports mods: .prevent, .stop, .capture, .self, .once, .native
$.registerDirective("on", {
  //priority must behind component

  isListener: true,

  mods: [],

  NOT_FILTER_MODS: ["native", "capture", "self", "once", "prevent", "stop"],

  bind() {
    let filters = [];
    let { mods, NOT_FILTER_MODS } = this;

    for (let i = 0; i < mods.length; i++) {
      let mod = mods[i];

      if (!NOT_FILTER_MODS.includes(mod)) {
        mods.splice(i--, 1);
        filters.push(mod);
      }
    }

    this.filters = filters.length ? "." + filters.join(".") : "";
  },

  update(newHandler, oldHandler) {
    let { el, vm, prop, mods } = this;
    let com = el.com();
    let isComEvent = com && com !== vm && !mods.includes("native");

    if (isComEvent) {
      if (oldHandler) {
        com.off(prop, oldHandler, vm);
      }

      if (newHandler) {
        com.on(prop, newHandler, vm);
      }
    } else {
      let eventName = prop + this.filters;
      let isCapture = mods.includes("capture");

      if (oldHandler) {
        el.off(eventName, oldHandler, isCapture);
      }

      if (newHandler) {
        newHandler = this.wrapHandler(el, newHandler);
        el.on(eventName, newHandler, isCapture);
      }
    }

    this.handler = newHandler;
  },

  wrapHandler(el, handler) {
    let { prop, mods, vm } = this;

    let wrappedHandler = (e) => {
      if (mods.includes("self") && e.target !== el[0]) {
        return;
      }

      if (mods.includes("once")) {
        el.off(prop, wrappedHandler, mods.includes("capture"));
      }

      if (mods.includes("prevent")) {
        e.preventDefault();
      }

      if (mods.includes("stop")) {
        e.stopPropagation();
      }

      handler.call(vm, e);
    };

    return wrappedHandler;
  },
});

//:src="url", cant use
//:class="'class1 class2'", :class="[class1, class2]", :class="{class1: value1, class2: value2}", :class.class1="value1"
//:style same as :class, otherwise :style.name.px="value"
//:attr="{name: value}", :attr.name="value"
//not support :="{a, b}", but support :="obj"
//use .camel to support properties like viewBox
//use .px to add px as unit, .percentage to add %, .url to add url()
$.registerDirective("bind", {
  priority: 600,

  prop: "",

  mods: [],

  bind() {
    let { el, prop } = this;
    let com = el.com();

    if (com && !["class", "style", "attr"].includes(prop)) {
      if (com !== this.vm) {
        this.com = com;
      }
    }
  },

  update(newValue, oldValue) {
    let { el, prop } = this;

    if (this.com) {
      this.updateCom(newValue);
    } else if (prop === "attr") {
      this.updateAttr(newValue, oldValue);
    } else if (prop === "class") {
      this.updateClass(newValue, oldValue);
    } else if (prop === "style") {
      this.updateStyle(newValue, oldValue);
    } else {
      newValue = util.isNullOrUndefined(newValue) ? "" : newValue;

      //reset value of textarea to the same value will reset insert postition to the start
      let isEditableProp = prop === "value" || prop === "innerHTML";

      //we need to ignore setting src to '' for <img> in Firefox, or the pseudo will not work. we choose other ways to
      if ($.env.isFirefox && el[0].localName === "img" && prop === "src") {
        if (el[0].src !== newValue) {
          el[0].src = newValue;
        }

        if (!newValue) {
          el[0].removeAttribute(prop);
        }
      } else {
        if (!isEditableProp) {
          el[0][prop] = newValue;
        }
      }
    }
  },

  updateCom(value) {
    let { com, prop } = this;

    if (prop) {
      com[prop] = value;
    } else if (value && typeof value === "object") {
      util.assign(com, value);
    }
  },

  updateAttr(newValue, oldValue) {
    let mod0 = this.mods[0];

    if (mod0) {
      if ([false, undefined, null].includes(newValue)) {
        this.removeAttribute(mod0);
      } else {
        this.setAttribute(mod0, newValue);
      }
    } else {
      let oldObj = util.isObject(oldValue) ? oldValue : {};
      let newObj = util.isObject(newValue) ? newValue : {};
      let { add, remove } = this.compare(oldObj, newObj);

      if (remove.length > 0) {
        for (let attr of remove) {
          this.removeAttribute(attr);
        }
      }

      if (add.length > 0) {
        for (let attr of add) {
          this.setAttribute(attr, newValue[attr]);
        }
      }
    }
  },

  setAttribute(name, value) {
    let { el } = this;

    if (name.startsWith("xlink:")) {
      el[0].setAttributeNS("http://www.w3.org/1999/xlink", name, value);
    } else {
      el[0].setAttribute(name, value);
    }
  },

  removeAttribute(name) {
    let { el } = this;

    if (name.startsWith("xlink:")) {
      el[0].removeAttributeNS("http://www.w3.org/1999/xlink", name);
    } else {
      el[0].removeAttribute(name);
    }
  },

  compare(oldObj = {}, newObj = {}) {
    let add = [];
    let remove = [];
    let falseValues = [false, undefined, null];

    for (let key in oldObj) {
      let oldValue = oldObj[key];
      let newValue = newObj[key];

      if (!falseValues.includes(oldValue) && falseValues.includes(newValue)) {
        remove.push(key);
      }
    }

    for (let key in newObj) {
      let oldValue = oldObj[key];
      let newValue = newObj[key];

      if (oldValue !== newValue) {
        add.push(key);
      }
    }

    return {
      add,
      remove,
    };
  },

  updateClass(newValue, oldValue) {
    let { el } = this;
    let oldObj = this.parseClass(oldValue);
    let newObj = this.parseClass(newValue);
    let { add, remove } = this.compare(oldObj, newObj);

    if (remove.length > 0) {
      el.removeClass(remove.join(" "));
    }

    if (add.length > 0) {
      el.addClass(add.join(" "));
    }
  },

  parseClass(value) {
    let mod0 = this.mods[0];
    let obj = {};

    if (mod0) {
      if (value) {
        obj[mod0] = true;
      }
    } else if (Array.isArray(value)) {
      for (let item of value) {
        if (typeof item === "object") {
          for (let key in item) {
            obj[key] = !!item[key];
          }
        } else {
          for (let cls of String(item).split(/\s+/)) {
            obj[cls] = true;
          }
        }
      }
    } else if (value && typeof value === "object") {
      for (let key in value) {
        obj[key] = !!value[key];
      }
    } else if (typeof value === "string") {
      if (/\s/.test(value)) {
        for (let cls of value.split(/\s+/)) {
          obj[cls] = true;
        }
      } else if (value) {
        obj[value] = true;
      }
    }

    return obj;
  },

  updateStyle(newValue, oldValue) {
    let oldObj = this.parseStyle(oldValue);
    let newObj = this.parseStyle(newValue);
    let { add, remove } = this.compare(oldObj, newObj);
    let willAddPX = this.mods.includes("px");
    let willAddPercentage = this.mods.includes("percent");
    let willAddURL = this.mods.includes("url");

    if (add.length + remove.length > 0) {
      let obj = {};

      for (let key of remove) {
        obj[key] = "";
      }

      for (let key of add) {
        let value = newObj[key];

        if (util.isNullOrUndefined(value)) {
          value = "";
        } else if (willAddPX) {
          value = value + "px";
        } else if (willAddPercentage) {
          value = value + "%";
        } else if (willAddURL) {
          value = 'url("' + value + '")';
        }

        obj[key] = value;
      }

      this.el.css(obj);
    }
  },

  parseStyle(value) {
    let mod0 = this.mods[0];
    let obj = {};

    if (mod0) {
      if (!util.isNullOrUndefined(value)) {
        obj[mod0] = value;
      }
    } else if (Array.isArray(value)) {
      for (let item of value) {
        if (typeof item === "object") {
          util.assign(obj, item);
        } else {
          for (let style of String(item).split(/\s*;\s*/)) {
            let [k, v] = style.split(/\s*:\s*/);
            if (k && v) {
              obj[k] = v;
            }
          }
        }
      }
    } else if (util.isObject(value)) {
      obj = value;
    } else if (value && !util.isNullOrUndefined(value)) {
      for (let style of String(value).split(/\s*;\s*/)) {
        let [k, v] = style.split(/\s*:\s*/);
        if (k && v) {
          obj[k] = v;
        }
      }
    }

    return obj;
  },
});

//supports mods: .lazy, .number
$.registerDirective("model", {
  priority: 600,

  mods: [],

  bind() {
    let { el } = this;
    let com = el.com();
    let { type, localName } = el[0];
    let isFormField = ["input", "select", "textarea"].includes(localName);
    let isLazy = this.mods.includes("lazy");

    this.isBoolValue =
      localName === "input" && (type === "checkbox" || type === "radio");
    this.isMultiSelect = localName === "select" && el[0].multiple;

    if (com) {
      this.prop = com._modelProperty || "value";
      this.eventName = "change";
    } else if (this.isBoolValue) {
      this.prop = "checked";
      this.eventName = "change";
    } else if (isFormField) {
      this.prop = "value";
      this.eventName = isLazy ? "change" : "input";
    } else {
      this.prop = "innerHTML";
      this.eventName = isLazy ? "blur" : "input"; //div@contendeditable cant trigger change event
    }

    if (com && com !== this.vm) {
      this.com = com;
      com.on("change", this.onComChange, this);
    } else {
      this.locked = false;
      el.on(this.eventName, this.onInputOrChange, this);

      //we just want to makesure the value equals to the value of final state
      if (this.eventName === "input") {
        let lazyEventName = this.prop === "innerHTML" ? "blur" : "change";
        el.on(lazyEventName, this.onInputOrChange, this);
      }
    }
  },

  onComChange(value) {
    let isNumber = this.mods.includes("number");
    if (isNumber) {
      value = Number(value);
    }

    this.watcher.set(value);
  },

  onInputOrChange(e) {
    let inputValue = this.el[0][this.prop];

    if (this.isBoolValue) {
      this.setBoolValue(inputValue);
    } else {
      this.setInputValue(inputValue);
    }

    this.locked = true;
    queues.addTask(() => {
      this.locked = false;

      //write value back to input
      if (e.type === "change") {
        this.update(this.watcher.value);
      }
    });
  },

  setBoolValue(inputValue) {
    let { vm, watcher } = this;
    let value = this.watcher.value;

    watcher.set(!!inputValue);
  },

  setInputValue(inputValue) {
    let { el, vm, watcher } = this;
    let isNumber = this.mods.includes("number");

    if (this.isMultiSelect) {
      let value = Array.from(el[0].options)
        .filter((o) => o.selected)
        .map((o) => o.value);

      if (isNumber) {
        value = value.map(Number);
      }

      watcher.set(value);
    } else {
      if (isNumber) {
        let numValue = Number(inputValue);
        watcher.set(numValue);
      } else {
        watcher.set(inputValue);
      }
    }
  },

  update(value) {
    if (this.com) {
      this.updateCom(value);
    } else {
      if (this.locked) {
        return;
      }

      if (this.isBoolValue) {
        this.updateBooleanValue(value);
      } else {
        this.updateInputValue(value);
      }
    }
  },

  updateCom(value) {
    let { prop, com } = this;

    if (prop) {
      com[prop] = value;
    } else if (value && typeof value === "object") {
      util.assign(com, value);
    }
  },

  updateBooleanValue(value) {
    let { el, prop } = this;
    el[0][prop] = !!value;
  },

  updateInputValue(value) {
    let { el, prop, isMultiSelect } = this;

    if (isMultiSelect && !Array.isArray(value)) {
      throw new Error(
        '"model" directive of select[multiple] requires an array as value'
      );
    }

    if (isMultiSelect) {
      for (let option of el[0].options) {
        option.selected = value.includes(option.value);
      }
    } else {
      el[0][prop] = util.isNullOrUndefined(value) ? "" : value;
    }
  },
});

//<componentName></componentName>
$.registerDirective("component", {
  priority: 800, //higher than bind & model

  isLiteral: true,

  closest: null,

  bind() {
    this.com = null;
  },

  update(name) {
    let { vm } = this;
    let com = (this.com = this.createCom(name));
  },

  createCom(name) {
    let { el, vm } = this;

    let options = {
      parent: vm,
      el,
      _closest: this.closest,
      _isCreatedByComponentDir: true,
    };

    return $.newComponent(name, options);
  },
});

/*
"if" will cause it's sub directives and watchers not been linked when no need
but there is a bug here, consider we have a checkbox:value=true and f-if="value":

                       OUTER  WATCHER  INNER
linked                 true   true     true
inner change           true   true     false
trigger change event   false  true     false  --locked by f-if
outer changed to true  true   true     false  --watcher compare true=true, not update inner, bug happens

add a updateEvenVMInactive property to watcher to solve it
*/
$.registerDirective("if", {
  priority: 700,

  mods: [],

  bind() {
    for (let el of this.els) {
      $(el).hide();
    }
  },

  update(newIndex, oldIndex) {
    if (this.els[oldIndex]) {
      this.hide(this.els[oldIndex]);
    }

    if (this.els[newIndex]) {
      this.show(this.els[newIndex]);
    }
  },

  show(el) {
    let transition = el._transition;

    if (transition) {
      $(el).show();
      transition.enterAfterUpdated();
    } else {
      $(el).show();
    }
  },

  hide(el) {
    let transition = el._transition;

    if (transition) {
      transition.leaveAfterUpdated((finish) => {
        if (finish) {
          $(el).hide();
        }
      });
    } else {
      $(el).hide();
    }
  },
});

$.registerDirective("else-if", {
  priority: 700,
});

$.registerDirective("else", {
  priority: 700,
});

//f-for="key in data"
//f-for="key, value in data"
//f-for=", value in data"
//f-for="key, value, index in data"
//f-for="value of data"
//f-for="a = b to c"
//f-for="a = 0 to 5 step 1"	//0, 1, 2, 3, 4
//f-for="a = 5 to 0 step 1"	//5, 4, 3, 2, 1
//datas should be both value type or both object type
//data should not has duplicate values or objects
//when animation been played
//	1. No new item (all caches hit) and removed some items, play leave animation
//	2. Add one item and not first time rendering, play enter animation
$.registerDirective("for", {
  priority: 900,

  isTerminal: true,

  loop: null,

  bind() {
    let { el, exp } = this;

    el.before((this.startMark = document.createComment("for " + exp)));
    el.after((this.endMark = document.createComment("end for")));
    el.remove();

    this.coms = [];
    this.map = new Map();
  },

  update(data, oldData) {
    let { type, keyKey, indexKey, valueAssigner } = this.loop;
    let array = this.getLoopArray(data);
    let oldComs = this.coms;
    let oldMap = this.map;
    let newComs = [];
    let newMap = new Map();
    let notMappedComs = [];
    let mappedComSet = new Set();

    for (let [value] of array) {
      let com = oldMap.get(value);
      if (com) {
        mappedComSet.add(com);
      }
    }

    for (let com of oldComs) {
      if (!mappedComSet.has(com)) {
        notMappedComs.push(com);
      }
    }

    for (
      let index = 0, len = array.length, prevEl = this.startMark;
      index < len;
      index++
    ) {
      let [value, key] = array[index];
      let com = newMap.has(value) ? null : oldMap.get(value);

      if (!com) {
        com = notMappedComs.length > 0 ? notMappedComs.shift() : null;
      }

      //same value may appear for twice, so we need to check if com for value has been used
      if (com) {
        if (prevEl.nextElementSibling !== com.el[0]) {
          $(prevEl).after(com.el);
        }

        if (keyKey) {
          com[keyKey] = key;
        }

        if (indexKey) {
          com[indexKey] = index;
        }

        if (valueAssigner) {
          valueAssigner.call(com, value);
        }
      } else {
        com = this.createCom(prevEl, value, key, index);
      }

      prevEl = com.el[0];
      newComs.push(com);
      newMap.set(value, com);
    }

    for (let com of notMappedComs) {
      this.removeCom(com);
    }

    this.coms = newComs;
    this.map = newMap;
  },

  getLoopArray(data) {
    let { type } = this.loop;

    if (type === "to") {
      return this.getLoopArrayForTypeTo(data);
    } else if (type === "of") {
      return this.getLoopArrayForTypeOf(data);
    } else {
      return this.getLoopArrayForTypeIn(data);
    }
  },

  getLoopArrayForTypeTo(data) {
    let [from, to, step] = data;
    let array = [];

    if (from <= to) {
      for (let i = from, index = 0; i <= to; i += step) {
        array.push([i, index]);
      }
    } else {
      for (let i = from, index = 0; i >= to; i -= step) {
        array.push([i, index]);
      }
    }

    return array;
  },

  getLoopArrayForTypeOf(data) {
    let array = [];

    if (data) {
      let index = 0;
      for (let value of data) {
        array.push([value, index++]);
      }
    }

    return array;
  },

  getLoopArrayForTypeIn(data) {
    let array = [];

    if (data) {
      if (Array.isArray(data)) {
        for (let i = 0, len = data.length; i < len; i++) {
          array.push([data[i], i]);
        }
      } else {
        this.keys = Object.keys(data);

        for (let key of this.keys) {
          array.push([data[key], key]);
        }
      }
    }

    return array;
  },

  createCom(prevEl, value, key, index) {
    let { valueAssigner, keyKey, indexKey } = this.loop;
    let newEl = this.el[0].cloneNode(true);

    $(prevEl).after(newEl);

    let com = Object.create(this.vm);

    let options = {
      el: newEl,
      parent: this.vm,
      _name: "",
      template: null,
      _inherit: true,
    };

    if (keyKey) {
      options[keyKey] = key;
    }

    if (indexKey) {
      options[indexKey] = index;
    }

    if (valueAssigner) {
      valueAssigner.call(options, value);
    }

    BaseComponent.call(com, options);

    return com;
  },

  removeCom(com) {
    let transition = com.el[0]._transition;
    if (transition) {
      transition.leaveAfterUpdated(() => {
        com.destroy();
      });
    } else {
      com.destroy();
    }
  },
});

//used to skip compiling
$.registerDirective("skip", {
  isTerminal: true,
  priority: 1000,
});

/*transition Directive*/
$.registerDirective("transition", {
  isLiteral: true,

  update(name) {
    let { el, vm } = this;
    let transition = el[0]._transition;

    if (transition) {
      transition.updateName(name);
    } else {
      el[0]._transition = new Transition(vm, el, name);
    }
  },

  unbind() {
    let { el } = this;

    if (el[0]._transition) {
      el[0]._transition.clear();
      delete el[0]._transition;
    }
  },
});

function Transition(vm, el, name) {
  this.vm = vm;
  this.el = el;
  this.name = name;
  this._transitionCleaner = null;
}

Transition.prototype = {
  updateName(name) {
    this.name = name;
  },

  //makesure transition proeprties have been fully updated
  enterAfterUpdated(fn) {
    queues.addTask(() => {
      this.enter(fn);
    });
  },

  leaveAfterUpdated(fn) {
    queues.addTask(() => {
      this.leave(fn);
    });
  },

  enter(fn) {
    let { vm, el, name } = this;

    this.clearLastCSSTransitionEndHandler();

    let onEntered = (finish) => {
      if (fn) {
        fn(finish);
      }
    };

    if ($.transitions[name]) {
      this.jsEnter(onEntered);
    } else {
      this.classEnter(onEntered);
    }
  },

  leave(fn) {
    let { vm, el, name } = this;

    this.clearLastCSSTransitionEndHandler();
    el.css("pointer-events", "none");

    let onLeaved = (finish) => {
      el.css("pointer-events", "");

      if (fn) {
        fn(finish);
      }
    };

    if ($.transitions[name]) {
      this.jsLeave(onLeaved);
    } else {
      this.classLeave(onLeaved);
    }
  },

  jsEnter(onEntered) {
    let jsTransition = $.transitions[this.name];

    if (jsTransition.enter) {
      this._transitionCleaner = jsTransition.enter(this.el, onEntered);
    } else {
      onEntered(true);
    }
  },

  jsLeave(onLeaved) {
    let jsTransition = $.transitions[this.name];

    if (jsTransition.leave) {
      this._transitionCleaner = jsTransition.leave(this.el, onLeaved);
    } else {
      onLeaved(true);
    }
  },

  classEnter(fn) {
    let { el, name } = this;
    let enterClass = name + "-enter";
    let canceled = false;

    el.css("transition", "none");
    el.addClass(enterClass, enterClass + "-from");

    //requestAnimationFrame and then create a micro task to make sure relayout completed
    requestAnimationFrame(() => {
      queues.addTask(() => {
        if (canceled) {
          return;
        }

        el.css("transition", "");
        el.removeClass(enterClass + "-from");
        el.addClass(enterClass + "-to");

        let onEnd = (finish) => {
          el.removeClass(enterClass, enterClass + "-to");
          fn(finish);
        };

        this.onceTransitionEnd(onEnd);
      });
    });

    this._transitionCleaner = () => {
      canceled = true;
    };
  },

  classLeave(fn) {
    let { el, name } = this;
    let leaveClass = name + "-leave";
    let canceled = false;

    el.addClass(leaveClass, leaveClass + "-from");
    el.css("transition", "none");

    requestAnimationFrame(() => {
      queues.addTask(() => {
        if (canceled) {
          return;
        }

        el.css("transition", "");
        el.removeClass(leaveClass + "-from");
        el.addClass(leaveClass + "-to");

        let onEnd = (finish) => {
          el.removeClass(leaveClass, leaveClass + "-to");
          fn(finish);
        };

        this.onceTransitionEnd(onEnd);
      });
    });

    this._transitionCleaner = () => {
      canceled = true;
    };
  },

  clearLastCSSTransitionEndHandler() {
    if (this._transitionCleaner) {
      this._transitionCleaner();
    }
  },

  onceTransitionEnd(onEnd) {
    let { el } = this;
    let transitionDuration = parseFloat(el.css("transition-duration")) || 0;
    let animationDuration = parseFloat(el.css("animation-duration")) || 0;
    let eventName = transitionDuration > 0 ? "transitionend" : "animationend";
    let duration = (transitionDuration || animationDuration) * 1000;

    let onFinish = () => {
      this._transitionCleaner = null;
      el.css("pointer-events", "");
      onEnd(true);
    };

    let onTransitionEnd = () => {
      defer.cancel();
      onFinish();
    };

    let onTimeout = () => {
      el.off(eventName, onTransitionEnd);
      onFinish();
    };

    el.once(eventName, onTransitionEnd);

    let defer = $.defer(onTimeout, duration + 50);

    this._transitionCleaner = () => {
      defer.cancel();
      el.off(eventName, onTransitionEnd);
      onEnd(false);
    };
  },

  clear() {
    this.clearLastCSSTransitionEndHandler();
  },
};

$.registerTransition("slide", {
  enter(el, fn) {
    el.slideDown(fn);
    return el.stop.bind(el);
  },

  leave(el, fn) {
    el.slideUp(fn);
    return el.stop.bind(el);
  },
});

//show or hide, with transition
$.registerDirective("show", {
  priority: 10, //higher than transition

  update(value, oldValue) {
    let { el } = this;
    let transition = el[0]._transition;

    if (transition && oldValue !== undefined) {
      if (value) {
        el.show();
        transition.enterAfterUpdated();
      } else {
        transition.leaveAfterUpdated((finish) => {
          if (finish) {
            el.hide();
          }
        });
      }
    } else {
      if (value) {
        el.show();
      } else {
        el.hide();
      }
    }
  },
});

$.registerDirective("hide", {
  priority: 10,

  update(value, oldValue) {
    let { el } = this;
    let transition = el[0]._transition;

    if (transition && oldValue !== undefined) {
      if (value) {
        transition.leaveAfterUpdated((finish) => {
          if (finish) {
            el.hide();
          }
        });
      } else {
        el.show();
        transition.enterAfterUpdated();
      }
    } else {
      if (value) {
        el.hide();
      } else {
        el.show();
      }
    }
  },
});

$.registerFilter("trans", (key, ...args) => {
  return i18n.tr(key, ...args);
});

$.registerDirective("focus", {
  isLiteral: true,

  update() {
    $.nextTick(() => {
      this.el[0].focus();
    });
  },
});

$.registerDirective("trans", {
  bind() {
    //fix el from element to its first child node
    let { el } = this;
    this.textNode = el[0].firstChild;
  },

  update(value) {
    this.textNode.textContent = value;
  },
});

/** COMPATIBLE WITH OLD APIS **/
$.register = $.registerComponent;
$.registerDir = $.registerDirective;
$.registerPlugin = $.registerMixin;
BaseComponent.prototype.createFromTemplate =
  BaseComponent.prototype.createFromHTML;

$.newDirective = function (name, el, options) {
  let Dir = $.directives[name];

  if (!Dir) {
    throw new Error('No directive named "' + name + '" existed');
  }

  options.el = el;
  options.isOld = true;

  return new Dir(options);
};

//components and directives
//we want to make sure the instance prepared immediately, then call its init after dom ready
$.registerOnce = function (selector, options) {
  if (!options) {
    options = selector;
    selector = "";
  }

  if (typeof options === "function") {
    options = {
      init: options,
    };
  }

  if (selector) {
    options.selector = selector;
  }

  options.init = options.init || function () {};
  options.mixins = options.plugins || options.mixins;
  var instance = $.extend(Object.create(SingleInstance.prototype), options);

  if (document.readyState === "complete") {
    var els = $(options.selector || "body");
    if (els.length) {
      SingleInstance.call(instance, els);
    }
  } else {
    //must can bind events here
    $.Emitter.call(instance);

    $.onDomReady(function () {
      $.defer(function () {
        var els = $(options.selector || "body");
        if (els.length) {
          SingleInstance.call(instance, els);
        }
      });
    });
  }

  return instance;
};

$.com = function (name) {
  return $.components[name] || $.directives[name];
};

$.newCom = function (name, el, options) {
  if (!(el instanceof $) && String(el) === "[object Object]") {
    options = el;
    el = null;
  }

  options = options || {};
  options.isOld = true;
  options.el = el;

  if ($.components[name]) {
    return $.newComponent(name, options);
  } else {
    return $.newDirective(name, el, options);
  }
};

$.applyCom = function (el) {
  $(el).applyCom();
};

$.releaseCom = function (el) {
  $(el).releaseCom();
};

$.fn.applyCom = function () {
  var created = false;

  if (this[0]) {
    if (!this.com()) {
      for (var name in $.components) {
        var Com = $.components[name];
        var selector = Com.prototype.selector;

        if (selector && this.is(selector)) {
          $.newCom(name, this, { isOld: true });
          created = true;
          break;
        }
      }
    }

    if (!created) {
      if (this.com()) {
        this.com()._initSubForEl(this.com().el);
        this.com().initSubBySelector(this);
      } else {
        $.newApp({ el: this, isOld: true });
      }
    }
  }

  return this;
};

$.fn.releaseCom = function () {
  var com = this.com();

  if (com) {
    for (var i = 0; i < com.children.length; i++) {
      com.children[i].destroy();
    }

    for (var i = 0; i < com.directives.length; i++) {
      com.directives[i].destroy();
    }
  }

  this.empty();

  return this;
};

$.fn.newCom = function (name, options) {
  return $.newCom(name, this, options);
};
